


































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CampaignDto from '@/models/Campaigns/CampaignDto';
import { CampaignListModule } from '@/store/modules/campaignList';
import PageNames from '@/router/PageNames';
import CreateCampaignRequest from '@/models/Campaigns/CreateCampaignRequest';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import EmailTemplate from '@/models/EmailTemplates/EmailTemplateDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import ActivityCategoryDto from '@/models/Activities/ActivityCategoryDto';

@Component({
    name: 'CampaignCreate'
})
export default class CampaignCreate extends GiganautVueDialog {

  entity: CampaignDto = new CampaignDto();
  desks: DeskDto[] = [];
  activityCategories: ActivityCategoryDto[] = [];

  get activeCategories() {
    return this.activityCategories.filter(c => c.isActive);
  }

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CampaignDto();
    
      if (AgencySettingsModule.agencyUsers.length === 0) {
        AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.branches) {
        await AgencySettingsModule.getBranches();
      }
      if (AgencySettingsModule.positions) {
        await AgencySettingsModule.getEmailTemplates();
      }
      await this.loadActivityCategories();
    }
  }

  async loadActivityCategories() {
    try {
      const response = await ajax.get('/api/v1/agency/activity-categories');
      this.activityCategories = response.data || [];
    } catch (error) {
      AppModule.handleApiError(error);
      this.activityCategories = [];
    }
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  @Watch('entity.branch') 
  async onBranchChanged(newVal: BranchDto, oldVal: BranchDto){
    if (newVal) {
      this.desks = newVal.desks;
    } else {
      this.entity.deskId = null;
      this.entity.desk = null;
      this.desks = [];
    }
  }

  get emailTemplates() {
    return AgencySettingsModule.emailTemplates;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get loading() {
    return CampaignListModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new CreateCampaignRequest()
    request.name = this.entity.name;
    request.ownerId = this.entity.owner.id;
    request.categoryId = this.entity.category ? this.entity.category.id : '';
    request.emailTemplateId = this.entity.emailTemplate.id;
    request.isTest = this.entity.isTest;
    request.testEmailAddresses = this.entity.testEmailAddresses;
    if (this.entity.branch) {
      request.branchId = this.entity.branch.id;
    } else {
      request.branchId = null;
    }
    if (this.entity.desk) {
      request.deskId = this.entity.desk.id;
    } else {
      request.deskId = null;
    }
    await CampaignListModule.createCampaign(request)
    if (CampaignListModule.newCampaignId !== '') {
      this.$router.push({ name: PageNames.AgencyCampaignDetails, params: { campaignid: CampaignListModule.newCampaignId } });
    }
    this.dialog = false;
  }
}
